import isEqual from 'lodash-es/isEqual'

import { EMPTY_STRING } from '../../constants/common'
import { REQUEST_ENTITY } from '../../constants/entity'
import {
  DATE_LIST_TYPE,
  LABEL_LIST_TYPE,
  RATING_LIST_TYPE,
  USER_LIST_TYPE,
} from '../../constants/filter'
import { INHABITANT_STATUS } from '../../constants/inhabitant'
import { REQUEST_STATUS } from '../../constants/request'
import { ROLE_TRANSLATION_ALIASES } from '../../constants/user'
import i18n from '../../i18n'

export function getFilterItemLabel({
  entity,
  filterKey,
  filterSecondKey,
  listType,
  option,
  query,
}) {
  if (listType === 'role') {
    return i18n.t(ROLE_TRANSLATION_ALIASES[option.value])
  }

  if (listType === 'status') {
    if (isEqual(entity, REQUEST_ENTITY)) {
      return i18n.t(REQUEST_STATUS[option.value].text)
    }

    if (isEqual(entity, INHABITANT_STATUS)) {
      return i18n.t(INHABITANT_STATUS[option.value].text)
    }

    return option.label
  }

  if (listType === USER_LIST_TYPE) {
    return option.value === null || option.is_persistent
      ? i18n.t(option.label.fullname)
      : option.label.fullname
  }

  if (listType === LABEL_LIST_TYPE) {
    return option.label.title
  }

  if (listType === RATING_LIST_TYPE) {
    return option.value
      ? i18n.t('Filter.StarCountLabelKey', { count: option.value })
      : option.label
  }

  if (listType === DATE_LIST_TYPE) {
    const startDate = query[filterKey]?.label || EMPTY_STRING
    let endDate = query[filterSecondKey]?.label || EMPTY_STRING

    const prefix = startDate ? EMPTY_STRING : '...'
    const suffix = endDate ? EMPTY_STRING : '...'

    let divider = EMPTY_STRING

    if (startDate === endDate) {
      endDate = EMPTY_STRING
    } else {
      divider = ' - '
    }

    return `${prefix}${startDate}${divider}${endDate}${suffix}`
  }

  return option.label
}

export function getFilterCountEmpty() {
  return null
}

export function hasAvailableActions(actions) {
  return actions.filter(Boolean).length > 0
}
